import React from 'react'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, ARTICLE_CAROUSEL_DEFAULTS } from '../../moduleRegistry'
import { ArticleCarouselHeading } from './ArticleCarouselHeading'
import { ArticleCarouselSubheading } from './ArticleCarouselSubheading'
import { ArticleCarousel } from './ArticleCarousel'
import { MoreResources } from './MoreResources'
import { ARTICLE_CAROUSEL_ARTICLES } from './articles'
import '../../styles/ArticleCarouselModule/ArticleCarouselModule.scss'

export const ArticleCarouselModule = () => {
  const { heading, subheading } = useModuleConfig(MODULE_KEYS.articleCarousel, ARTICLE_CAROUSEL_DEFAULTS)

  return (
    <section
      className="article-carousel-module"
      aria-labelledby="article-carousel-heading"
      data-testid="article-carousel-module"
    >
      <ArticleCarouselHeading heading={heading} fallback={ARTICLE_CAROUSEL_DEFAULTS.heading} />
      <ArticleCarouselSubheading subheading={subheading} fallback={ARTICLE_CAROUSEL_DEFAULTS.subheading} />
      <ArticleCarousel articles={ARTICLE_CAROUSEL_ARTICLES} />
      <MoreResources />
    </section>
  )
}
